import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['slide', 'dot', 'dotsContainer']

  static values = {
    autoRotateDelay: { type: Number, default: 5000 },
    pauseDuration: { type: Number, default: 10000 },
  }

  connect() {
    this.currentSlide = 0
    this.totalSlides = this.slideTargets.length
    this.touchStartX = 0
    this.touchEndX = 0
    this.touchStartY = 0
    this.touchEndY = 0
    this.autoRotateInterval = null
    this.autoRotateResumeTimeout = null
    this.initializeNavigation()
    this.initializeTouch()
    this.updateDots()
    this.startAutoRotate()
  }

  disconnect() {
    this.stopAutoRotate()
  }

  startAutoRotate() {
    this.stopAutoRotate()
    this.autoRotateInterval = setInterval(() => {
      this.next()
    }, this.autoRotateDelayValue)
  }

  stopAutoRotate() {
    if (this.autoRotateInterval) {
      clearInterval(this.autoRotateInterval)
      this.autoRotateInterval = null
    }
    if (this.autoRotateResumeTimeout) {
      clearTimeout(this.autoRotateResumeTimeout)
      this.autoRotateResumeTimeout = null
    }
  }

  pauseAutoRotate() {
    this.stopAutoRotate()
    this.autoRotateResumeTimeout = setTimeout(() => {
      this.startAutoRotate()
    }, this.pauseDurationValue)
  }

  showSlide(index) {
    this.slideTargets.forEach((slide) => {
      slide.classList.remove('active')
    })
    this.slideTargets[index].classList.add('active')
    this.updateDots()
  }

  updateDots() {
    if (this.hasDotTarget) {
      this.dotTargets.forEach((dot, index) => {
        if (index === this.currentSlide) {
          dot.classList.add('active')
        } else {
          dot.classList.remove('active')
        }
      })
    }
  }

  next() {
    this.currentSlide = (this.currentSlide + 1) % this.totalSlides
    this.showSlide(this.currentSlide)
  }

  prev() {
    this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides
    this.showSlide(this.currentSlide)
  }

  nextManual() {
    this.next()
    this.pauseAutoRotate()
  }

  prevManual() {
    this.prev()
    this.pauseAutoRotate()
  }

  goToSlide(event) {
    const slideIndex = parseInt(event.currentTarget.dataset.slide, 10)
    this.currentSlide = slideIndex
    this.showSlide(this.currentSlide)
    this.pauseAutoRotate()
  }

  initializeNavigation() {
    const navButtons = this.element.querySelectorAll('.carousel-nav')
    navButtons.forEach((btn) => {
      btn.addEventListener('mouseenter', () => {
        btn.style.opacity = '1'
      })
      btn.addEventListener('mouseleave', () => {
        btn.style.opacity = '0.8'
      })
    })
  }

  initializeTouch() {
    this.element.addEventListener('touchstart', (e) => {
      this.touchStartX = e.changedTouches[0].screenX
      this.touchStartY = e.changedTouches[0].screenY
    }, { passive: true })

    this.element.addEventListener('touchend', (e) => {
      this.touchEndX = e.changedTouches[0].screenX
      this.touchEndY = e.changedTouches[0].screenY
      this.handleSwipe()
    }, { passive: true })
  }

  handleSwipe() {
    const swipeThreshold = 50
    const horizontalDiff = this.touchStartX - this.touchEndX
    const verticalDiff = this.touchStartY - this.touchEndY

    const isHorizontalSwipe = Math.abs(horizontalDiff) > swipeThreshold
    const isPrimaryDirection = Math.abs(horizontalDiff) > Math.abs(verticalDiff)

    if (isHorizontalSwipe && isPrimaryDirection) {
      if (horizontalDiff > 0) {
        this.nextManual()
      } else {
        this.prevManual()
      }
    }
  }
}
